import { createSelector } from 'reselect';

import { PCGState } from 'Reducers/PrivateClientGroups';
import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';
import { getPcgUsers, getPrivateClientGroups } from 'Selectors/common';

const getUserId = (_state: AdminState | ClientState, userId: string, _includeDeleted: boolean, _pcgId: string) => userId;
const getIncludeDeleted = (_state: AdminState | ClientState, _userId: string, includeDeleted: boolean, _pcgId: string) => includeDeleted;

export const getPcgUsersArrayByUser = createSelector(
    [ getPcgUsers, getUserId, getIncludeDeleted ],
    (pcgUsers, userId, includeDeleted) => {
        return Object.keys(pcgUsers)
            .map(id => pcgUsers[id])
            .filter(pcg => {
                if (includeDeleted) {
                    return pcg && pcg.UserId === userId;
                } else {
                    return pcg && pcg.UserId === userId && !pcg.IsDeleted;
                }
            });
    }
);

export const getPcgNumbersByUser = createSelector(
    [ getPcgUsers, getPrivateClientGroups, getUserId ],
    (pcgUsers, privateClientGroups, userId) => {
        const result: PCGState = {};
        for (const key in pcgUsers) {
            const pcgUser = pcgUsers[key];
            if (privateClientGroups[pcgUser.PCGId]) {
                const pcg = privateClientGroups[pcgUser.PCGId];
                if (pcgUser.UserId === userId && !pcg.IsDeleted && !pcgUser.IsDeleted) {
                    result[pcgUser.PCGId] = {
                        ...privateClientGroups[pcgUser.PCGId],
                        PCGNumber: privateClientGroups[pcgUser.PCGId].PCGNumber.toUpperCase()
                    };
                }
            }
        }

        return result;
    }
);